import findDialogTitle from '../../utils/findDialogTitle';
import { eventHasRun } from '../../utils/eventTracker';

export const CLOSED = 'closed';
export const OPENED = 'opened';

function publishDialogAction(win, action, { timeStamp, target: element }) {
	let eventObject;

	if (action && [CLOSED, OPENED].includes(action)) {
		const eventType = `ddc.dialog.${action}`;

		if (action === OPENED) {
			document
				.querySelectorAll('.ui-dialog')
				.forEach((dialog) =>
					dialog.removeAttribute('ws-tracking-dialog-latest')
				);
			element
				?.closest?.('.ui-dialog')
				?.setAttribute?.('ws-tracking-dialog-latest', true);
		}

		if (
			!eventHasRun(eventType, {
				timeStamp
			})
		) {
			const dialog =
				element?.closest?.('.ui-dialog') ||
				element?.closest?.('.modal-dialog') ||
				element?.querySelector?.('.ddc-mobile-slidein') ||
				document.querySelector(
					'.ui-dialog[ws-tracking-dialog-latest="true"]'
				);

			const form = dialog?.querySelector('form');

			eventObject = {
				eventType,
				eventData: {
					element,
					pageName: win.DDC?.dataLayer?.page?.pageInfo?.pageName,
					dialogTitle: findDialogTitle(dialog),
					hasForm: !!form,
					trackingId: form?.dataset?.formTrackingId || ''
				}
			};
		}
	}

	return eventObject;
}

export default publishDialogAction;
